import { useState } from "react";
import { FaPaperPlane } from "react-icons/fa6";
import { SelectPppoeUser } from "../../../../../components/forms/selects/SelectPppoeUser";
import { SelectWaDevice } from "../../../../../components/forms/selects/SelectWaDevice";
import { TextAreaDefault } from "../../../../../components/forms/TextAreaDefault";
import { ModalWraperWhatsapp } from "./wraper";
import { WaMessageService } from "../../../../../services/WaMessageService";

export const SendWaMessage = ({
    refresh,
    openModal,
    setOpenModal,
}) => {
    const [loading, setLoading] = useState(false);

    const [formData, setFormData] = useState({
        device: null,
        type: "private",
        recieper: null,      // Untuk mode private (object pelanggan)
        recipients: "",      // Untuk mode broadcast (string baris baru)
        message: "",
    });

    const closeModal = () => {
        setOpenModal(false);
        setFormData({
            device: null,
            type: "private",
            recieper: null,
            recipients: "",
            message: "",
        });
        setLoading(false);
    };

    const handleSendMessage = async (e) => {
        e.preventDefault();

        // Validasi basic sebelum menembak API
        if (!formData?.device?.phone_number) {
            alert("Silakan pilih device WhatsApp terlebih dahulu.");
            return;
        }

        try {
            setLoading(true);
            
            let finalNumbers = "";

            // LOGIC PEMILAHAN: Tipe Private vs Broadcast
            if (formData.type === "private") {
                finalNumbers = formData?.recieper?.phone_number ?? "";
                if (!finalNumbers) {
                    alert("Pelanggan yang dipilih tidak memiliki nomor telepon.");
                    setLoading(false);
                    return;
                }
            } else {
                // Ambil per baris, buang baris kosong, lalu gabungkan dengan '|'
                const lines = formData.recipients.split("\n");
                const cleanLines = lines
                    .map((num) => num.trim())
                    .filter((num) => num !== "");

                if (cleanLines.length === 0) {
                    alert("Silakan masukkan minimal satu nomor untuk broadcast.");
                    setLoading(false);
                    return;
                }
                finalNumbers = cleanLines.join("|");
            }

            const body = {
                sender: formData?.device?.phone_number,
                number: finalNumbers,
                message: formData?.message,
            };

            console.log("Payload data dikirim:", body);

            await WaMessageService.send({ data: body });
            
            if (refresh) refresh();
            closeModal();
        } catch (err) {
            console.error("Gagal mengirim pesan:", err);
        } finally {
            setLoading(false);
        }
    };

    return (
        <ModalWraperWhatsapp
            isOpen={openModal}
            setIsOpen={setOpenModal}
            title="Kirim Pesan WhatsApp"
        >
            <form
                onSubmit={handleSendMessage}
                className="space-y-5"
            >
                {/* Device */}
                <SelectWaDevice
                    label="Pilih Device Whatsapp"
                    value={formData.device}
                    onChange={(value) =>
                        setFormData((prev) => ({
                            ...prev,
                            device: value,
                        }))
                    }
                />

                {/* Tipe Pengiriman */}
                <div>
                    <label className="block text-xs font-semibold text-slate-400 mb-2 uppercase tracking-wider">
                        Tipe Pengiriman
                    </label>

                    <div className="grid grid-cols-2 gap-3">
                        {[
                            {
                                value: "private",
                                label: "Private Chat",
                                icon: "👤",
                            },
                            {
                                value: "broadcast",
                                label: "Broadcast",
                                icon: "📢",
                            },
                        ].map((item) => (
                            <label
                                key={item.value}
                                className={`cursor-pointer rounded-xl border px-4 py-3 transition-all ${
                                    formData.type === item.value
                                        ? "border-cyan-500 bg-cyan-500/10"
                                        : "border-slate-700 hover:bg-slate-800/50"
                                }`}
                            >
                                <input
                                    type="radio"
                                    name="message_type"
                                    value={item.value}
                                    checked={formData.type === item.value}
                                    onChange={(e) =>
                                        setFormData((prev) => ({
                                            ...prev,
                                            type: e.target.value,
                                        }))
                                    }
                                    className="sr-only"
                                />

                                <div className="flex items-center gap-3">
                                    <div
                                        className={`w-5 h-5 rounded-full border-2 flex items-center justify-center ${
                                            formData.type === item.value
                                                ? "border-cyan-500"
                                                : "border-slate-500"
                                        }`}
                                    >
                                        {formData.type === item.value && (
                                            <div className="w-2.5 h-2.5 rounded-full bg-cyan-500" />
                                        )}
                                    </div>

                                    <span className="text-xl">{item.icon}</span>
                                    <span className="font-medium text-sm text-slate-200">
                                        {item.label}
                                    </span>
                                </div>
                            </label>
                        ))}
                    </div>
                </div>

                {/* TAMPILKAN BERDASARKAN TIPE PENGIRIMAN */}
                {formData.type === "private" ? (
                    /* Mode Private: Pilih dari data pelanggan */
                    <SelectPppoeUser
                        label="Pilih Pelanggan"
                        value={formData.recieper?.id}
                        onChange={(value) => {
                            setFormData((prev) => ({
                                ...prev,
                                recieper: value,
                            }));
                        }}
                    />
                ) : (
                    /* Mode Broadcast: Manual Input Textarea */
                    <div>
                        <label className="block text-xs font-semibold text-slate-400 mb-2 uppercase tracking-wider">
                            Nomor Broadcast
                        </label>

                        <textarea
                            rows={4}
                            value={formData.recipients}
                            onChange={(e) =>
                                setFormData((prev) => ({
                                    ...prev,
                                    recipients: e.target.value,
                                }))
                            }
                            className="w-full px-4 py-3 text-xs rounded-xl bg-slate-800/60 border border-slate-700 text-slate-100 placeholder-slate-500 focus:outline-none focus:border-cyan-500"
                            placeholder={"628123456789\n628987654321"}
                        />

                        <p className="text-xs text-slate-500 mt-2">
                            Satu nomor per baris. Sistem otomatis menggabungkannya dengan pemisah "|" saat dikirim.
                        </p>
                    </div>
                )}

                {/* Message */}
                <TextAreaDefault
                    id="message_body"
                    label="Isi Pesan"
                    placeholder="Tulis pesan anda disini..."
                    value={formData.message}
                    onChange={(e) =>
                        setFormData((prev) => ({
                            ...prev,
                            message: e.target.value,
                        }))
                    }
                />

                <div className="flex gap-3">
                    <button
                        type="button"
                        onClick={closeModal}
                        className="flex-1 py-3 rounded-xl border border-slate-700 text-slate-300 transition-colors hover:bg-slate-800"
                    >
                        Batal
                    </button>

                    <button
                        type="submit"
                        disabled={loading}
                        className="flex-1 py-3 rounded-xl bg-cyan-600 hover:bg-cyan-500 disabled:bg-slate-700 text-white font-semibold flex items-center justify-center gap-2 transition-colors"
                    >
                        {loading ? (
                            <>Mengirim...</>
                        ) : (
                            <>
                                <FaPaperPlane />
                                Kirim Pesan
                            </>
                        )}
                    </button>
                </div>
            </form>
        </ModalWraperWhatsapp>
    );
};